// A checkbox answer as true / false, or null when the value is not one.
//
// Visual views show a tick or a cross; spreadsheets say Yes / No (the API's
// `format_answer_value`). Both start from this reading of the stored value,
// which is a boolean, the string "true" / "false", or an already-worded
// "Yes" / "No" (the shared-task API, line-items cells).
import FormFieldParser from './FormFieldParser';

const TRUE_WORDS = new Set(['true', 'yes', '1', 'on']);
const FALSE_WORDS = new Set(['false', 'no', '0', 'off']);

// A photo's own answer (`data_fields[]` entry, which carries its type).
export function perImageCheckbox(field) {
  return field?.type === 'checkbox' ? checkboxState(field.value) : null;
}

// A tick or a cross in running text, where an icon cannot go (a caption
// string). Both glyphs are in every system UI font the browser falls back to.
export function checkboxGlyph(checked) {
  return checked ? '\u2713' : '\u2717';
}

export function checkboxState(value) {
  if (typeof value === 'boolean') return value;
  if (value === null || value === undefined) return null;
  const low = String(value).trim().toLowerCase();
  if (TRUE_WORDS.has(low)) return true;
  if (FALSE_WORDS.has(low)) return false;
  return null;
}

// One task answer as true / false when its field is a checkbox, else null.
// The type comes from the task's `headers`, or from the template for a task
// created through the API, which carries none (as `collectedData` reads it).
export function taskCheckboxAnswer(task, fieldKey, value, templateFields) {
  const headerType = FormFieldParser.parseHeaders(task?.headers)[fieldKey]?.type;
  const templateField = (Array.isArray(templateFields) ? templateFields : [])
    .find(f => (f?.id || f?.field_id) === fieldKey);
  const isCheckbox = headerType === 'checkbox'
    || (templateField?.type || templateField?.field_type) === 'checkbox';
  return isCheckbox ? checkboxState(value) : null;
}
